/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function clientVisitDateFilter(): angular.IFilterService {
        const filter = (input: any) => {
            if (!input) {
                return "";
            }

            var output: string = "";
            var currentStartOfWeek = moment().startOf('week');
            var value = input.toString().trim();
            var valueStartOfWeek = moment(value).startOf('week');
            var shortdate = moment(value).meevoFormat('L');
            var weeksDiff = currentStartOfWeek.diff(valueStartOfWeek, "week") as number;
            if (weeksDiff === 0) {
                output += " this week ";
            }
            else {
                if (weeksDiff === 1) {
                    output += " last week ";
                }
                else if (weeksDiff > 52) {
                    output += " > 1 year ";
                }
                else {
                    if (!weeksDiff) {
                        return input;
                    }
                    else {
                        output += " " + weeksDiff.toString() + " weeks ago ";
                    }
                }
            }

            return ("Last Visit: " + shortdate + output).trim();

        };
        return filter;
    }

  
    angular.module("meevo.components.filters")
        .filter("clientVisitDate", clientVisitDateFilter);
}